import { render, staticRenderFns } from "./PurchasePlan.vue?vue&type=template&id=4bb02ea0&"
import script from "./PurchasePlan.vue?vue&type=script&lang=js&"
export * from "./PurchasePlan.vue?vue&type=script&lang=js&"
import style0 from "./PurchasePlan.vue?vue&type=style&index=0&id=4bb02ea0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports